export default {
	sec_01: {
		title: {
			one: '온라인으로 송금하는',
			two: '안전하고 재미있는 ',
			three: '방법',
		},
		desc: {
			one: '전 세계 거의 모든 곳에서 가족과 친구에게',
			two: '빠르게 송금 할 수 있는 간단한 방법입니다.',
		},
		btn: {
			one: '자산보내기',
			two: '앱 다운로드',
		},
	},
	sec_04: {
		title: '모든 전송을 최대한 활용',
		cards: {
			one: {
				title: '양방향 메시지',
				description: {
					one: '친구 간의 결제가 맞는지 한번 더 확인을 위해',
					two: '메시지를 교환하세요.',
				},
			},
			two: {
				title: '무료 옵션',
				description: {
					one: 'JP WORLD PAY포인트 카드 사용,',
					two: 'JP WORLD PAY잔액을 확인 후 해외에서',
					three: '온라인으로 송금 할 수 있습니다.',
				},
			},
			three: {
				title: '빠른 액세스',
				description: {
					one: '암호화폐 송금시',
					two: '받는 사람은 기다림 없이',
					three: '바로 받을 수 있습니다.',
				},
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: '연중무휴',
				two: '모니터링',
			},
			desc: {
				one: '암호화 기술을 통해 우리는 귀하의 송금이 안전한지',
				two: '확인하기 위해 최선을 다합니다.',
			},
		},
		two: {
			title: {
				one: '전 세계로 송금',
			},
			desc: {
				one: '수취인에게 JP WORLD PAY서비스를 사용하여',
				two: '전 세계 어디든 송금하세요.',
				three: '전 세계 어디든 친구 및 가족에게 온라인으로 송금',
			},
		},
	},
	sec_09: {
		title: {
			one: '0 JPYS',
			two: 'JP WORLD PAY내 거래 수수료',
		},
		one: {
			desc: {
				one: '타행지갑 출금시 JP WORLD PAY',
				two: '잔액에서 돈을 보낼 때 0%',
			},
		},
	},
};
